$(document).ready(function() {
	if(!document.querySelector('.GPC0103')) return false;
	var c0103 = {
		modelId : null,
		// 20200408 START 박지영 B type 추가
		type: null,
		// 20200408 END
		// 20200624 LGEPA-27
		reviewConfirmSelectiveUseFlag: 'N',
		// 20200624 LGEPA-27 End
		/* LGEJP-161 : 20201215 add */
		nickName : null,
		nickNameFlag : null,
		nickNameCloseEdit : false,
		nickNameCloseCommnet : false,
		/*// LGEJP-161 : 20201215 add */
		// 20200413 START 박지영 : loginURL 추가
		loginURL: $('.navigation').eq(0).data('login-check'),
		// 20200413 END
		review : {
			template: $(document.getElementById('reviewBoxTemplate')),
			init: function(){
				this.msgLess = this.template.data('less') ? this.template.data('less') : 'Hide Review';
				this.msgMore = this.template.data('more') ? this.template.data('more') : 'View More';
				this.writeInit();
				if($('#editReviewForm').get(0)){
					this.editInit();
				}
				this.addEvent();
			},
			writeInit: function(){
				//LGECO-30 start
				if ($('input[name=agreementType]').val() == 'M') {
					/* LGEITF-376 modify */
				    if (sessionStorage.getItem('ACCESS_TOKEN').length > 1) {
				         $('.agreement-area').css('display','none');
				    }
				} else {
				    $('.check-area.agree-check.email').css('display','none');
				}
				//LGECO-30 end
				// review title
				checkTextLength($(writeReviewForm.title), $(writeReviewForm.title).siblings('.char-count').find('.char-current'));
				// review text
				checkTextLength($(writeReviewForm.review), $(writeReviewForm.review).siblings('.char-count').find('.char-current'));
				this.initRates();
				this.writeReview();
			},
			editInit: function(){
				// review title
				checkTextLength($(editReviewForm.title), $(editReviewForm.title).siblings('.char-count').find('.char-current'));
				// review text
				checkTextLength($(editReviewForm.review), $(editReviewForm.review).siblings('.char-count').find('.char-current'));
				this.editReview();
			},
			initRates: function(){
				$('.GPC0103 .field-block.rates input[type="radio"]').on({
					change: function(e){
						var $currentLi = $(e.currentTarget).closest('li'),
							$currentUl = $(e.currentTarget).closest('ul'),
							$rateArea = $(e.currentTarget).closest('.rates-area');
						$currentUl.find('li').removeClass('on');
						$currentLi.addClass('on').prevUntil().addClass('on');
						$rateArea.find('.rates-number strong').text(e.currentTarget.value);
						$(e.currentTarget).closest('.rates-area').data('selected', true);
					},
					clear: function(e){
						var $currentLi = $(e.currentTarget).closest('li'),
							$currentUl = $(e.currentTarget).closest('ul'),
							$rateArea = $(e.currentTarget).closest('.rates-area');
						$currentUl.find('li').removeClass('on');
						$rateArea.find('.rates-number strong').text(0);
						writeReviewForm.rating.value = 0;
						$(e.currentTarget).closest('.rates-area').data('selected', false);
					}
				});
				$('.GPC0103 .field-block.rates li').on({
					mouseenter: function(e){
						console.log($(e.currentTarget).closest('.rates-area').data('selected'));
						if($(e.currentTarget).closest('.rates-area').data('selected') != true) {
							$(e.currentTarget).siblings().removeClass('on');
							$(e.currentTarget).addClass('on').prevUntil().addClass('on');
						}
					},
					mouseleave: function(e){
						if($(e.currentTarget).closest('.rates-area').data('selected') != true) {
							$(e.currentTarget).removeClass('on').siblings().removeClass('on');
						}
					}
				});
			},
			writeReview: function(){
				$(writeReviewForm).on({
					submit: function(e){
						e.preventDefault();
						
						/* LGECN-214 Start */
						if(COUNTRY_CODE.toLowerCase() == 'cn'){
							baiduTrackEvent('comment_submit', $(this).parents().find('.GPC0009'), 'PDP', { list_name:$lg_cggroup });
						}
						/* LGECN-214 End */
						
						if($(this).checkValidation()) {
							$(writeReviewForm).find('button[type=submit]').attr('disabled', true);
							var _this = this;
							if((_this.password == undefined && _this.nickname == undefined) || c0103.checkPasswordPattern(_this.password.value)){

								/* LGEJP-161 : 20210111 add */
								$(_this).find('textarea[name=review]').val($(_this).find('textarea[name=review]').val().replace(/\n\n$/gm, ''));
								/*// LGEJP-161 : 20210111 add */
								ajax.call(_this.action, xssfilter($(_this).serialize()), 'json', function(data){
									//console.log(data);
									if(data.status == 'success' && data.data[0].isNicDup != "duplicate" && data.data[0].reviewEmailRestrictionFlag != "N"){			//LGCOMHR-26 reviewEmailRestrictionFlag추가
										
										// 20200624 LGEPA-27
										// 20200511 START 박지영 ie 버그 수정
										var rating = writeReviewForm.rating.value || $(writeReviewForm.rating).filter(':checked').val();
										// 20200511 END
										
										//PJTGADL-2
										var suffixCode = $('.js-compare').attr('data-model-suffixcode');
										var modelCode = $('.js-compare').attr('data-model-id');
										var price = $('.js-compare').attr('data-price');
										if(price == '.' || price == '.00' || price == '0.0' || price == '0'){
											price = "";
										} 
										var msrpPrice = $('.js-compare').attr('data-msrp');
										if(msrpPrice == '.' || msrpPrice == '.00' || msrpPrice == '0.0' || msrpPrice == '0'){
											msrpPrice = "";
										} 
										dataLayer.push({
											'event'			: 'review_complete_click',
											'superCategory'	: _dl.page_name.super_category,
											'category'		: standardData.level2,
											'subcategory'	: standardData.level3,
											'modelYear'		: _dl.page_name.model_year,
											'modelName'		: _dl.products[0].model_name,
											'modelCode'		: modelCode,
											'salesModelCode': _dl.products[0].sales_model_code,
											'sku'			: _dl.page_name.sku,
											'suffix'        : suffixCode,
											'bu'            : standardData.level1,
											'reviewScore'   : rating,
											'price'         : price,
											'currencyCode'  : $('.currency-code').val(),
											'dimension185'  : $('.navigation').attr('data-obs-group'),
											'metric4'       : msrpPrice
										}); console.log('review_complete_click');
										
										// 20200408 START 박지영 B type 추가
										if(!c0103.type) {
											// type A
											// 20200416 START 박지영 - 리로드 후 review 찾아가도록 수정
											location.replace(location.pathname+'?review=y')
											//location.reload();
											// 20200416 END
										} else if (c0103.type && c0103.reviewConfirmSelectiveUseFlag == 'Y' && Number(rating) > 3) {
											// type B
											// 선택적 리뷰 승인 사용 중 별점 3 초과 건은 즉시 리로드 후 review 찾아가도록 수정
											location.replace(location.pathname+'?review=y')
										// 20200624 LGEPA-27 End
										} else {
											// type B
											/* LGEJP-161 : 20201218 add */
											var nickNameValue = writeReviewForm.nickname ? writeReviewForm.nickname.value : $('header.navigation .gnb-login .welcome .name').text();
											if(c0103.nickNameFlag == 'Y' && !!c0103.nickName) nickNameValue = c0103.nickName;
											/*// LGEJP-161 : 20201218 add */
											
											var template = c0103.review.template.clone().html(),
												title = writeReviewForm.title.value,
												review = writeReviewForm.review.value,
												nickname = nickNameValue, /* LGEJP-161 : 20201218 modify */
												recommendFlag = writeReviewForm.recommendFlag.value,
												creationDate = $(template).find('.submit-description').attr('data-time'),
												ratesPercentage = (Number(rating) / 5 * 100) +"%";
											review = review.replace(/\r\n|\n|\r/g, '<br>');
											template = template.replace(/\*reviewReId\*/g, '')
																.replace(/\*reviewId\*/g, '')
																.replace(/\*rates\*/g, rating)
																.replace(/\*ratespercentage\*/g, ratesPercentage)
																.replace(/\*author\*/g, nickname)
																.replace(/\*time\*/g, creationDate)
																.replace(/\*title\*/g, title)
																.replace(/\*reviewText\*/g, review);
																
											var $template = $(template);
											if(recommendFlag == "Y") {
												$template.find('.disrecommend').remove();
											}else if(recommendFlag == "N") {
												$template.find('.recommend').remove();
											}else {
												$template.find('.disrecommend').remove();
												$template.find('.recommend').remove();
											}

											//ie fix
											$template.find('.carmine-star').css({
												width: ratesPercentage
											});

											$template.find('.comment-area').remove();
											$template.find('.review-control').remove();
											$template.find('.deleted-review').remove();

											$('.GPC0103 .review-list-body').prepend($template.get(0).outerHTML);

											writeReviewForm.reset();
											$(writeReviewForm.rates).trigger('clear');

											$('.GPC0103 .no-review-desc').remove(); // no review description contents;
											$('.GPC0103 .review-list-area').removeClass('no-review'); // no review description contents;

											$('.GPC0103 .write-button').removeClass('hide');
											$('.GPC0103 .write-review-area.write').slideUp(function(){
												$(this).removeClass('open');
												$('html, body').animate({
													// 20200408 START 박지영 : 스크롤 위치 수정
													scrollTop: $('.GPC0103 .review-list-body').offset().top - parseInt($('.GPC0011').outerHeight())
													// 20200408 END
												});
											});
										}
										// 20200408 END

									}else if(data.data[0].isNicDup == "duplicate" && data.data[0].reviewEmailRestrictionFlag != "N"){				//LGCOMHR-26 reviewEmailRestrictionFlag추가
										// var msg = data.data.errorMsg;
										//var fieldBlock = $(writeReviewForm.nickname).closest('.field-block');
										//fieldBlock.addClass('error').find('.ajax-msg').show().siblings().hide();
										$('#modal_duplicate_error').modal();
										$(writeReviewForm).find('button[type=submit]').attr('disabled', false);
									//LGCOMHR-26 Start
									}else if(data.data[0].reviewEmailRestrictionFlag == "N"){
										var msg = data.data[0].reviewEmailRestrictionMsg;
										var fieldBlock = $(writeReviewForm.email).closest('.field-block');
										fieldBlock.addClass('error').find('.ajax-msg').text(msg).show().siblings().hide();
										$(writeReviewForm).find('button[type=submit]').attr('disabled', false);
									}
									//LGCOMHR-26 End
								});
							}else {
								$(_this.password).closest('.field-block').addClass('error').find('.invalid').show().siblings().hide();
								$(_this.password).focus();
								$(writeReviewForm).find('button[type=submit]').attr('disabled', false);
							}
						}
					}
				});
				// cancel review
				$(writeReviewForm).on({
					click: function(e){
						writeReviewForm.reset();
						$(writeReviewForm.rating).trigger('clear');
						$('.GPC0103 .write-review-area.write').slideUp(function(){
							$(this).removeClass('open');
							$('.GPC0103 .write-button').removeClass('hide');
							$('html, body').animate({
								// 20200408 START 박지영 : 스크롤 위치 수정
								scrollTop: $('.GPC0103').offset().top - parseInt($('.GPC0011').outerHeight())
								// 20200408 END
							});
						});
					}
				}, 'button.cancel');
			},
			pasteEditReview: function(reviewId, token){
				var sendData = {
					'reviewId' : reviewId,
					'modelId' : c0103.modelId,
					'accessToken' : token
				};
				ajax.call(editReviewForm.getAttribute('data-get-review'), sendData, 'json', function (data) {
					if(data.status == 'success' && data.data[0].reviewList[0]){
						p = data.data[0].reviewList[0];
						editReviewForm.modelId.value = p.modelId;
						editReviewForm.reviewId.value = p.reviewId;
						editReviewForm.title.value = p.title;
						editReviewForm.review.value = p.review;
						editReviewForm.nickname.value = editReviewSignIn.nickname.value
						editReviewForm.password.value = editReviewSignIn.password.value;
						/* LGEJP-161 : 20201215 modify */
						if(c0103.nickNameFlag == 'Y' && !!c0103.nickName) editReviewForm.frmNickname.value = c0103.nickName;
						/*// LGEJP-161 : 20201215 modify */

						// 20200511 START 박지영 : 로그인 했을때 리뷰 수정 시 nickname 처리 
						if(!!p.nickName && p.nickName != null && p.nickName != '') $(editReviewForm).data('nickname', p.nickName)
						// 20200511 END

						editReviewForm.rating.value = p.rating;
						editReviewForm.recommendFlag.value = p.recommendFlag;

						$(editReviewForm.title).trigger('keyup');
						$(editReviewForm.review).trigger('keyup');

						for (var i=0; i < editReviewForm.rating.length; i++) {
							if(editReviewForm.rating[i].value == p.rating) {
								editReviewForm.rating[i].checked = true;
								$(editReviewForm.rating[i]).trigger('change');
							}
						}

						for (var i=0; i < editReviewForm.recommendFlag.length; i++) {
							if(editReviewForm.recommendFlag[i].value == p.recommendFlag) {
								editReviewForm.recommendFlag[i].checked = true;
							}
						}

						$('html, body').animate({
							// 20200408 START 박지영 : 스크롤 위치 수정
							scrollTop: $('.GPC0103').offset().top - parseInt($('.GPC0011').outerHeight())
							// 20200408 END
						});
						$('.GPC0103 .write-review-area.write').removeClass('open').removeAttr('style');
						$('.GPC0103 .write-review-area.edit').slideDown(function(){
							$(this).addClass('open');
						});
						$('.GPC0103 .write-button').addClass('hide');

						$(editReviewForm.rating).focus();
					}
				});
			},
			editReview: function(){
				$(editReviewForm).on({
					submit: function(e){
						e.preventDefault();
						if($(this).checkValidation()) {
							$(editReviewForm).find('button[type=submit]').attr('disabled', true);
							// 20200507 START 박지영 - 수정된 리뷰 삭제를 위한 변수 추가 
							var reviewId = editReviewForm.reviewId.value
							// 20200507 END;
							/* LGEJP-161 : 20210111 add */
							$(this).find('textarea[name=review]').val($(this).find('textarea[name=review]').val().replace(/\n\n$/gm, ''));
							/*// LGEJP-161 : 20210111 add */
							ajax.call(this.action, xssfilter($(this).serialize()), 'json', function(data){
								if(data.status == 'success' && data.data[0].updateReview == 'success'){
									
									// 20200624 LGEPA-27
									// 20200511 START 박지영 ie 버그 수정
									var rating = editReviewForm.rating.value || $(editReviewForm.rating).filter(':checked').val();
									// 20200511 END
									
									// 20200408 START 박지영 B type 추가
									if(!c0103.type) {
										// type A
										// 20200416 START 박지영 - 리로드 후 review 찾아가도록 수정
										location.replace(location.pathname+'?review=y')
										//location.reload();
										// 20200416 END
									} else if (c0103.type && c0103.reviewConfirmSelectiveUseFlag == 'Y' && Number(rating) > 3) {
										// type B
										// 선택적 리뷰 승인 사용 중 별점 3 초과 건은 즉시 리로드 후 review 찾아가도록 수정
										location.replace(location.pathname+'?review=y')
									// 20200624 LGEPA-27 End
									} else {
										// type B
										var template = c0103.review.template.clone().html(),
											title = editReviewForm.title.value,
											review = editReviewForm.review.value,
											// 20200514 START 박지영 : nickname이 없는 경우 체크
											nickname = editReviewForm.nickname ? editReviewForm.nickname.value : null,
											// 20200514 END
											recommendFlag = editReviewForm.recommendFlag.value,
											creationDate = $(template).find('.submit-description').attr('data-time'),
											ratesPercentage = (Number(rating) / 5 * 100) +"%";
										review = review.replace(/\r\n|\n|\r/g, '<br>');

										// 20200511 START 박지영 : 로그인 했을때 리뷰 수정 시 nickname 처리 
										if(!!$(editReviewForm).data('nickname')) nickname = $(editReviewForm).data('nickname');
										// 20200511 END
										/* LGEJP-161 : 20201218 add */
										if(c0103.nickNameFlag == 'Y' && !!c0103.nickName) nickname = c0103.nickName;
										/*// LGEJP-161 : 20201218 add */

										template = template.replace(/\*reviewReId\*/g, '')
															.replace(/\*reviewId\*/g, '')
															.replace(/\*rates\*/g, rating)
															.replace(/\*ratespercentage\*/g, ratesPercentage)
															.replace(/\*author\*/g, nickname)
															.replace(/\*time\*/g, creationDate)
															.replace(/\*title\*/g, title)
															.replace(/\*reviewText\*/g, review);
															
										var $template = $(template);
										if(recommendFlag == "Y") {
											$template.find('.disrecommend').remove();
										}else if(recommendFlag == "N") {
											$template.find('.recommend').remove();
										}else {
											$template.find('.disrecommend').remove();
											$template.find('.recommend').remove();
										}

										//ie fix
										$template.find('.carmine-star').css({
											width: ratesPercentage
										});

										$template.find('.comment-area').remove();
										$template.find('.review-control').remove();
										$template.find('.deleted-review').remove();

										$('.GPC0103 .review-list-body').prepend($template.get(0).outerHTML);

										editReviewForm.reset();
										$(editReviewForm.rates).trigger('clear');

										$('.GPC0103 .no-review-desc').remove(); // no review description contents;
										$('.GPC0103 .review-list-area').removeClass('no-review'); // no review description contents;

										$('.GPC0103 .write-button').removeClass('hide');
										// 20200507 START 박지영 : 오타 수정
										$('.GPC0103 .write-review-area.edit').slideUp(function(){
										// 20200507 END
											$(this).removeClass('open');
											$('html, body').animate({
												// 20200408 START 박지영 : 스크롤 위치 수정
												scrollTop: $('.GPC0103 .review-list-body').offset().top - parseInt($('.GPC0011').outerHeight())
												// 20200408 END
											});
										});

										// 20200507 START 박지영 - 수정된 리뷰 항목 삭제
										// remove original review
										var orgReview = $('.GPC0103 .review-list-area .review-box[data-id='+reviewId+']');
										if(orgReview.length>0) orgReview.remove();
										// 20200507 END
									}
									// 20200408 END
								} else {
									var msg = data.data.errorMsg;
									var fieldBlock = $(editReviewForm.nickname).closest('.field-block');
									fieldBlock.addClass('error').find('.ajax-msg').text(msg).show().siblings().hide();
									$(editReviewForm).find('button[type=submit]').attr('disabled', false);
								}
							})
						}
					}
				});

				// cancel edit review
				$(editReviewForm).on({
					click: function(e){
						var reviewId = editReviewForm.reviewId.value;
						editReviewForm.reset();
						$(editReviewForm.rating).trigger('clear');
						$('.GPC0103 .write-review-area.edit').slideUp(function(){
							$(this).removeClass('open');
							$('.GPC0103 .write-button').removeClass('hide');
							if($('#'+reviewId).get(0)) {
								$('html, body').animate({
									// 20200408 START 박지영 : 스크롤 위치 수정
									scrollTop: $('#'+reviewId).offset().top - parseInt($('.GPC0011').outerHeight())
									// 20200408 END
								});
							}
						});
					}
				}, 'button.cancel');
			},
			currentFocus : null, //LGEJP-161 : 20210104 add
			addEvent: function(){
				var _this = this;
				// write review button event
				$(writeReviewButton).on({
					click: function(e){
						e.preventDefault();
						_this.currentFocus = $(this); //LGEJP-161 : 20210104 add
						if(this.getAttribute('href') == '#') {
							// guest or member
							var token = sessionStorage.getItem('ACCESS_TOKEN'); /* LGEITF-376 modify */
							var url = $(this).attr('data-check');
							if(token) {
								writeReviewForm.accessToken.value = token;
							}
							if(token && url) {
								ajax.noCacheCall(url, 'modelId='+c0103.modelId, 'json', function (data) {
									if(data.data[0].loginCheck == true) {
										if(data.data[0].isWritable == 0) {
											// member & duplicate
											$('#modal_duplicate_error').modal();
										} else {
											// member & is-writable
											if(!$('.GPC0103 .write-review-area.write').hasClass('open')) {
												$('.GPC0103 .write-review-area.write').slideDown(function(){
													$(this).addClass('open');
												});
												$('.GPC0103 .write-button').addClass('hide');
											}
											// LGEPH-335 Start
											if ($('input[name=reviewMoreInfoFlag]').val() == 'Y') {
												$('.check-area.agree-check.more-info').css('display','none');
											}
											// LGEPH-335 End
											
											/* LGEJP-161 : 20201210 add */
											if(!(!!data.data[0].nickName) && data.data[0].nickNameFlag == 'Y'){ //nick name
												$('#modal_nickname_edit').modal();
											}else if(!!data.data[0].nickName && data.data[0].nickNameFlag == 'Y'){
												c0103.nickName = data.data[0].nickName;
												c0103.nickNameFlag = data.data[0].nickNameFlag;
											}
											/*// LGEJP-161 : 20201210 add */
										}
									} else {
										// guest
										if(!$('.GPC0103 .write-review-area.write').hasClass('open')) {
											$('.GPC0103 .write-review-area.write').slideDown(function(){
												$(this).addClass('open');
											});
											$('.GPC0103 .write-button').addClass('hide');
										}
									}
								}, 'post');
							} else {
								//LGEGMC-260 start
								ajax.noCacheCall(url, 'modelId='+c0103.modelId, 'json', function (data) {
									if(data.data[0].isFakeReview == 'Y') {
										// guest & duplicate
										$('#modal_duplicate_error').modal();
									} else {
										// guest
										if(!$('.GPC0103 .write-review-area.write').hasClass('open')) {
											$('.GPC0103 .write-review-area.write').slideDown(function(){
												$(this).addClass('open');
											});
											$('.GPC0103 .write-button').addClass('hide');
										}
									}
								}, 'post');
								//LGEGMC-260 end
							}
						} else {
							window.location.href = $(this).attr('href');
						}
					}
				});
				/* LGEJP-161 : 20201210 add */
				$('#nickNameUpdateFrm').on({
					submit: function(e){
						e.preventDefault();
						if($(this).checkValidation()) {
							var fNickName = $(this).find('input[name=nickName]').val();
							ajax.noCacheCall($(this).data('ajax-url'), xssfilter($(this).serialize()), 'json', function (data) {
								if(data.status == 'success'){
									$('#modal_nickname_edit').modal('hide');
									c0103.nickName = fNickName;
									c0103.nickNameFlag = 'Y';
									if(!!$('#editReviewForm').length)editReviewForm.frmNickname.value = fNickName;
									
									if($('.write-review-area.edit').is(':visible')){
										$(editReviewForm.rating).focus();
									}else if($('.write-review-area.write').is(':visible')){
										$(writeReviewForm.rating).focus();
									}else if($('.post-comment-area').is(':visible')){
										$(commentWriteForm.commentText).focus();
									}						
								}else{
									console.log(data.status);
								}								
							}, 'post');
						}
					}					
				});
				$('#modal_nickname_edit').find('button[data-dismiss=modal]').on('click.close', function(e) {
					e.preventDefault();
					_this.nickNameClose();
				});
				$('#modal_nickname_edit').on('hidden.bs.modal', function () {
					// console.log("hidden modal");
					$('#modal_nickname_edit').on('keydown.nicknameClose');
				});
				$('#modal_nickname_edit').on('keydown.nicknameClose', function(e){
					if( e.keyCode === 27 ){
						_this.nickNameClose();
					}else{
						return;
					}
				});
				/* LGEJP-161 : 20201210 add */
				// edit review
				$('.GPC0103 .review-list-body').on({
					click: function(e){
						e.preventDefault();
						_this.currentFocus = $(this); //LGEJP-161 : 20210104 add
						var reviewId = $(e.currentTarget).closest('.review-box').attr('data-id');
						// login check;
						var token = sessionStorage.getItem('ACCESS_TOKEN'); /* LGEITF-376 modify */
						if(token) {
							// 20200413 START 박지영 : loginURL을 c0103.loginURL로 변경
							ajax.noCacheCall(c0103.loginURL, 'access_token='+token, 'json', function (data) {
							// 20200413 END
								var loginFlag = false;
								if (data.loginCheck && data.loginCheck == true) {
									loginFlag = true;
								}
								if (loginFlag) {
									// login 상태
									/* LGEJP-161 : 20201215 add */
									if(data.nickNameFlag == 'Y' ){
										if(!(!!data.user.nickName)){
											c0103.nickNameCloseEdit = true;
											$('#modal_nickname_edit').modal();
										}else{
											c0103.nickName = data.user.nickName;
										}
										c0103.nickNameFlag = data.nickNameFlag;
									}
									/*// LGEJP-161 : 20201215 add */
									_this.pasteEditReview(reviewId, token);
								}else {
									editReviewSignIn.reviewId.value = reviewId;
									// 20200423 START 박지영 - Sign in layer popup 띄울 때 nickname, password 초기화
									editReviewSignIn.nickname.value = '';
									editReviewSignIn.password.value = '';
									// 20200423 END
									$('#modal_signin_guest_edit').modal('show');
								}
							}, 'post');
						}else {
							editReviewSignIn.reviewId.value = reviewId;
								// 20200423 START 박지영 - Sign in layer popup 띄울 때 nickname, password 초기화
								editReviewSignIn.nickname.value = '';
								editReviewSignIn.password.value = '';
								// 20200423 END
							$('#modal_signin_guest_edit').modal('show');
						}
					}
				}, '.review-control .edit');
				// delete review / comment;
				$('.GPC0103 .review-list-body').on({
					click: function(e){
						e.preventDefault();
						var reviewId = $(e.currentTarget).closest('.review-box').attr('data-id');
						var commentId = $(e.currentTarget).closest('.comment-box').attr('data-id');
						commentId = commentId ? commentId : '';
						// login check;
						var token = sessionStorage.getItem('ACCESS_TOKEN'); /* LGEITF-376 modify */
						if(token) {
							// 20200413 START 박지영 : loginURL을 c0103.loginURL로 변경
							ajax.noCacheCall(c0103.loginURL, 'access_token='+token, 'json', function (data) {
							// 20200413 END
								var loginFlag = false;
								if (data.loginCheck && data.loginCheck == true) {
									loginFlag = true;
								}
								if (loginFlag) {
									// login 상태
									deleteReviewSignIn.reviewId.value = reviewId;
									deleteReviewSignIn.commentId.value = commentId;
									deleteReviewSignIn.accessToken.value = token;
									deleteReviewSignIn.nickname.value = '';
									deleteReviewSignIn.password.value = '';
									$('#modal_delete_confirm').modal('show');
								}else {
									deleteReviewSignIn.reviewId.value = reviewId;
									deleteReviewSignIn.commentId.value = commentId;
									// 20200423 START 박지영 - Sign in layer popup 띄울 때 nickname, password 초기화
									deleteReviewSignIn.nickname.value = '';
									deleteReviewSignIn.password.value = '';
									// 20200423 END
									$('#modal_signin_guest_delete').modal('show');
								}

								if(commentId && commentId != '') { // comment
									$('#modal_signin_guest_delete').data('status', 'comment');
								}else {
									$('#modal_signin_guest_delete').data('status', 'review');
								}
							}, 'post');
						}else {
							deleteReviewSignIn.reviewId.value = reviewId;
							deleteReviewSignIn.commentId.value = commentId;
							// 20200423 START 박지영 - Sign in layer popup 띄울 때 nickname, password 초기화
							deleteReviewSignIn.nickname.value = '';
							deleteReviewSignIn.password.value = '';
							// 20200423 END
							$('#modal_signin_guest_delete').modal('show');

							if(commentId && commentId != '') { // comment
								$('#modal_signin_guest_delete').data('status', 'comment');
							}else {
								$('#modal_signin_guest_delete').data('status', 'review');
							}
						}
					}
				}, '.review-control .delete, .comment-control .delete');

				// helpful event
				$('.GPC0103 .review-list-body').on({
					click: function(e){
						// 20200601 START 박지영 - Helpful 버튼 한번 이상 클릭 안되게 수정
						//if($(e.currentTarget).is('.on')) return false;
						//$(e.currentTarget).attr('disabled', true);						
						// 20200601 END
						/* LGEJP-161 : 20210111 add */
						var reviewOn = false;
						if($(e.currentTarget).is('.on')) reviewOn = true;
						/*// LGEJP-161 : 20210111 add */
						var reviewBox = $(e.currentTarget).closest('.review-box').get(0),
							reviewId = reviewBox.getAttribute('data-id'),
							modelId = c0103.modelId,
							sendData = {
								reviewId: reviewId,
								modelId: modelId, 
								reviewOn : reviewOn
							}

						if(typeof ePrivacyCookies=='undefined' || ePrivacyCookies.get('LGCOM_IMPROVEMENTS')) {
							ajax.call(e.delegateTarget.getAttribute('data-helpful-url'), sendData, 'json', function(data){
								if(data.status == 'success' && data.data) {
									$(e.currentTarget).find('.number').text(data.data[0].helpful);
									// 20200525 START 이상현 - review heplful button 클릭을 1회로 제한.
									//$(e.currentTarget).addClass('on').attr('disabled', true);
									// 20200525 END
									/* LGEJP-161 : 20210111 add */
									if($(e.currentTarget).is('.on')){
										$(e.currentTarget).removeClass('on');
									}else{
										$(e.currentTarget).addClass('on');
									}
									/*/ LGEJP-161 : 20210111 add */
									c0103.cookie.bake(modelId, reviewId);
									// 20200409 START 박지영 : Helpful 클릭 시, ajax 캐시 제거
									ajax.cacheParams = [];
									ajax.cacheDatas = [];
									// 20200409 END
								}
							});
						} else {
							ePrivacyCookies.view('click');
							return false;
						}
					}
				}, '.helpful-button');
			},
			/* LGEJP-161 : 20210104 add */
			nickNameClose : function(){
				if(c0103.nickNameCloseEdit){ // commnet
					$('.GPC0103 .write-review-area.edit').slideUp(function(){
						$(this).removeClass('open');
						$('html, body').animate({
							// 20200408 START 박지영 : 스크롤 위치 수정
							scrollTop: $('.GPC0103 .review-list-body').offset().top - parseInt($('.GPC0011').outerHeight())
							// 20200408 END
						});
					});
					$('.GPC0103 .review-control .edit').focus();
					c0103.nickNameCloseEdit = false;
				}else if(c0103.nickNameCloseCommnet){ //edit
					$('.GPC0103 .post-comment-area').remove();
					$('.GPC0103 .comment-menu').show();
					$('.GPC0103 .post-btn .post-comment').focus();
					c0103.nickNameCloseCommnet = false;
				}else{ //review write
					$('.GPC0103 .write-button').removeClass('hide');
					$('.GPC0103 .write-review-area.write').slideUp(function(){
						$(this).removeClass('open');
						$('html, body').animate({
							// 20200408 START 박지영 : 스크롤 위치 수정
							scrollTop: $('.GPC0103 .review-list-body').offset().top - parseInt($('.GPC0011').outerHeight())
							// 20200408 END
						});
					});
					$('.GPC0103 .write-button #writeReviewButton').focus();
				}
			}
			/*// LGEJP-161 : 20210104 add */
		},
		comment : {
			postTemplate: $(document.getElementById('postCommentTemplate')).clone().html(),
			commentTemplate: $(document.getElementById('commentBodyTemplate')),
			init: function(){
				this.addEvent();
			},
			writeComment: function(){
				$(commentWriteForm).on({
					submit: function(e){
						e.preventDefault();
						if($(this).checkValidation()) {
							$(commentWriteForm).find('button[type=submit]').attr('disabled', true);
							if((this.password == undefined && this.nickname == undefined) || c0103.checkPasswordPattern(this.password.value)){
								/* LGEJP-161 : 20210111 add */
								$(this).find('textarea[name=commentText]').val($(this).find('textarea[name=commentText]').val().replace(/\n\n$/gm, ''));
								/*// LGEJP-161 : 20210111 add */
								ajax.call(this.action, xssfilter($(this).serialize()), 'json', function(data){
									if(data.status == 'success' && data.data) {
										// 20200624 LGEPA-27
										// comment가 작성되는 review의 별점을 가져옴
										// var rating = $(commentWriteForm).closest('.review-box').find('.rating-number strong').text();
										
										// 20200408 START 박지영 B type 추가
										if(!c0103.type) {
											// type A
											// 20200416 START 박지영 - 리로드 후 review 찾아가도록 수정
											location.replace(location.pathname+'?review=y')
											//location.reload();
											// 20200416 END
										} else if (c0103.type && c0103.reviewConfirmSelectiveUseFlag == 'Y') {
											// type B
											// 선택적 리뷰 승인 사용 시 코멘트는 별점이 없어 바로 등록 후 리로드하여 review 찾아감
											location.replace(location.pathname+'?review=y')
										// 20200624 LGEPA-27 End
										} else {
											// type B
											/* LGEJP-161 : 20201218 add */
											var nickNameValue = commentWriteForm.nickname ? commentWriteForm.nickname.value : xssfilter($('header.navigation .gnb-login .welcome .name').text());
											if(c0103.nickNameFlag == 'Y' && !!c0103.nickName) nickNameValue = c0103.nickName;
											/*// LGEJP-161 : 20201218 add */
											
											var template = c0103.comment.commentTemplate.clone().html(),
												comment = commentWriteForm.commentText.value,
												// 20200514 START 박지영 : 로그인 했을때 리뷰 수정 시 nickname 처리 
												nickname = nickNameValue, /* LGEJP-161 : 20201218 modify */
												// 20200514 END
												creationDate = $(template).find('.submit-description').attr('data-time');

											comment = comment.replace(/\r\n|\n|\r/g, '<br>');
											template = template.replace(/\*commentReId\*/g, '') // p.commentReId + p.reviewId
																.replace(/\*commentId\*/g, '') // p.commentId
																.replace(/\*author\*/g, nickname)
																.replace(/\*time\*/g, creationDate)
																.replace(/\*commentText\*/g, comment);
											var $template = $(template);
											$template.find('.comment-control').remove();
											$template.find('.view-more-comment-box').remove();

											if($(e.currentTarget).closest('.comment-area').find('.comment-list-area')[0]){
												$(e.currentTarget).closest('.comment-area').find('.comment-list-area').prepend($template.find('.comment-box').get(0).outerHTML);
											}else {
												$(e.currentTarget).closest('.comment-area').append($template.get(0).outerHTML);
											}
											
											$('.GPC0103 .post-comment-area').remove();
											$('.GPC0103 .comment-menu').show();
										}
										// 20200408 END
									} else {
										$(commentWriteForm).find('button[type=submit]').attr('disabled', false);
									}
								});
							}else {
								$(this.password).closest('.field-block').addClass('error').find('.invalid').show().siblings().hide();
								$(this.password).focus();
								$(commentWriteForm).find('button[type=submit]').attr('disabled', false);
							}
						}
					}
				});

				// cancel comment
				$(commentWriteForm).on({
					click: function(e){
						commentWriteForm.reset();
						$(this).closest('.comment-area').find('.comment-menu').show();
						$('.GPC0103 .post-comment-area').remove();
					}
				}, 'button.cancel');
			},
			addEvent: function(){
				var _this = this;
				$('.GPC0103 .review-box').off('click').on({
					click: function(e){
						e.preventDefault();
						_this.currentFocus = $(this); //LGEJP-161 : 20210104 add
						if(typeof commentWriteForm !== "undefined") {
							$('.GPC0103 .post-comment-area').remove();
							$('.GPC0103 .comment-menu').show();
						}
						$(e.delegateTarget).find('.comment-header').after(_this.postTemplate);
						$(e.delegateTarget).find('.post-comment-area').hide();

						var token = sessionStorage.getItem('ACCESS_TOKEN'); /* LGEITF-376 modify */
						if(token) {
							// 20200413 START 박지영 : loginURL을 c0103.loginURL로 변경
							ajax.noCacheCall(c0103.loginURL, 'access_token='+token, 'json', function (data) {
							// 20200413 END
								if(data.loginCheck && data.loginCheck == true){
									$('.GPC0103 .guest-area').remove();
									/* LGEIS-129 : 20200901 add */
									if(COUNTRY_CODE == 'it') $('.GPC0103 .agreement-area').remove();									
									/* LGEIS-129 : 20200901 add */
									$(e.delegateTarget).find('.post-comment-area').show();
									/* LGEJP-161 : 20201210 add */
									if(data.nickNameFlag == 'Y' ){
										if(!(!!data.user.nickName)){
											c0103.nickNameCloseCommnet = true;
											$('#modal_nickname_edit').modal();
										}else{
											c0103.nickName = data.user.nickName;
										}
										c0103.nickNameFlag = data.nickNameFlag;
										c0103.commnetTarget = $(e.delegateTarget);
									}
									/*// LGEJP-161 : 20201210 add */
								}
							}, 'post');
						}else {
							$(e.delegateTarget).find('.post-comment-area').show();
						}

						$(e.delegateTarget).find('.comment-menu').hide();

						commentWriteForm.reviewId.value = e.delegateTarget.getAttribute('data-id');
						checkTextLength($(commentWriteForm.commentText), $(commentWriteForm.commentText).siblings('.char-count').find('.char-current'));
						c0103.comment.writeComment();
					}
				}, '.comment-area .post-comment');
				$('.GPC0103 .comment-list-area').off('click').on({
					click: function(e){
						e.preventDefault();
						if($(e.currentTarget).is('.view-more-comment')) {
							$(e.delegateTarget).addClass('open').removeClass('collapsed');
							$(e.currentTarget).closest('.review-box').find('.more-comment a').eq(0).focus();
						}else {
							$(e.delegateTarget).addClass('collapsed').removeClass('open');
							// 20200402 START 박지영 : hide comments 버튼 클릭시 스크롤 위치 수정
							var stickyHeight = 0;
							if($('.GPC0011').length>0) {
								stickyHeight = parseInt($('.GPC0011').outerHeight());
							}
							// 20200406 START 박지영 : 스크롤 위치 변경
							var st = parseInt($(e.delegateTarget).closest('.review-box').offset().top) - stickyHeight;
							// 20200406 END
							$('html, body').animate({
								scrollTop: st
							});
							// 20200402 END
						}
					}
				}, '.view-more-comment-box a');
			}
		},
		cookie: {
			name: 'LG5_ReviewHelpful',
			bake: function(modelId, reviewId){
				var _this = this;
				var cookie = getCookie(_this.name);
				if(cookie) {
					// var cookieArray = 
					cookie = cookie.indexOf(',') >= 0 ? cookie.split(',') : [cookie];
					var currentIdx = -1;
					for (var i = 0; i < cookie.length; i++) {
						if(cookie[i].indexOf(modelId) > -1) {
							currentIdx = i;
						}
					}

					if(currentIdx > -1){
						var currentReviewCookie = cookie[currentIdx].split(':')[1];
						currentReviewCookie = currentReviewCookie.indexOf('|') >= 0 ? currentReviewCookie.split('|') : [currentReviewCookie];

						if(currentReviewCookie.indexOf(reviewId) < 0) {
							currentReviewCookie.push(reviewId);
						}
						currentReviewCookie = currentReviewCookie.join('|');

						cookie[currentIdx] = modelId+":"+currentReviewCookie;
					}else {
						cookie.push(modelId+':'+reviewId);
					}

					cookie = cookie.join(',');
					if(typeof ePrivacyCookies=='undefined' || ePrivacyCookies.get('LGCOM_IMPROVEMENTS')) {
						// 20200608 START 박지영 - Helpful 관련 쿠키 값을 삭제할 수 있도록 하면서 발생하는 오류 수정
						cookie = cookie.replace(',,', ',');
						// 20200608 END
						setCookie(_this.name, cookie, true);
					}
				}else {
					var cookieArray = modelId+":"+reviewId;
					if(typeof ePrivacyCookies=='undefined' || ePrivacyCookies.get('LGCOM_IMPROVEMENTS')) {
						setCookie(_this.name, cookieArray, true);
					}
				}
			},
			// 20200608 START 박지영 - Helpful 관련 쿠키에서 특정 제품의 특정 리뷰를 제거하는 스크립트 추가
			remove: function(modelId, reviewId) {
				var _this = this;
				var cookie = getCookie(_this.name);
				if(cookie && cookie.indexOf(modelId)>=0 && cookie.indexOf(reviewId)>=0) {
					cookie = cookie.indexOf(',') >= 0 ? cookie.split(',') : [cookie];
					var currentIdx = -1;
					for (var i = 0; i < cookie.length; i++) {
						if(cookie[i].indexOf(modelId) > -1) {
							currentIdx = i;
						}
					}
					if(currentIdx > -1){
						var currentReviewCookie = cookie[currentIdx].split(':')[1];
						currentReviewCookie = currentReviewCookie.indexOf('|') >= 0 ? currentReviewCookie.split('|') : [currentReviewCookie];

						if(currentReviewCookie.indexOf(reviewId) >= 0) {
							currentReviewCookie.splice(currentReviewCookie.indexOf(reviewId), 1); // remove reviewId in cookie
						}
						currentReviewCookie = currentReviewCookie.join('|');

						if(currentReviewCookie.length==0 || (currentReviewCookie.length===1 && currentReviewCookie[0]==="")) {
							cookie[currentIdx] = '';
						} else {
							cookie[currentIdx] = modelId+":"+currentReviewCookie;
						}
					}
					cookie = cookie.join(',');
					if(typeof ePrivacyCookies=='undefined' || ePrivacyCookies.get('LGCOM_IMPROVEMENTS')) {
						cookie = cookie.replace(',,', ',');
						setCookie(_this.name, cookie, true);
					}
				}
			},
			// 20200608 END
			getHelpfulReview: function(modelId){
				var _this = this;
				var cookie = getCookie(_this.name);
				if(cookie) {
					cookie = cookie.indexOf(',') >= 0 ? cookie.split(',') : [cookie];
					var currentIdx = -1;
					for (var i = 0; i < cookie.length; i++) {
						if(cookie[i].indexOf(modelId) > -1) {
							currentIdx = i;
						}
					}

					if(currentIdx > -1) {
						var currentReviewCookie = cookie[currentIdx].split(':')[1];
						currentReviewCookie = currentReviewCookie.indexOf('|') >= 0 ? currentReviewCookie.split('|') : [currentReviewCookie];
						
						for (var i = 0; i < currentReviewCookie.length; i++) {
							// currentReviewCookie[i]
							// 20200525 START 이상현 - review heplful button 클릭을 1회로 제한.
							// 20200608 START 박지영 - Helpful이 0인 경우, 사용자 브라우저에 해당 제품의 해당 리뷰에 대한 쿠키가 남아있다면 삭제하도록 변경
							if(currentReviewCookie[i]) {
								var currCount = parseInt($('.GPC0103 .review-box[data-id='+currentReviewCookie[i]+']').find('.helpful-button .number').text());
								if(currCount>=0) {
									_this.remove(modelId, currentReviewCookie[i]);
								} else {
									$('.GPC0103 .review-box[data-id='+currentReviewCookie[i]+']').find('.helpful-button').addClass('on').attr("disabled", true);
								}
							}
							// 20200608 END
							// 20200525 END
						}
					}
				}
			}
		},
		list: {
			init: function(){
				this.addEvent();
				this.changeForm();
				// c0103.cookie.getHelpfulReview(c0103.modelId);
				// initialize review list
				$(reviewListControlForm).trigger('change', true);
			},
			changeForm: function(){
				var _this = this;
				$(reviewListControlForm).on({
					change: function(e, flag){
						var isExpander = $('.GPC0103').data('focus') == true;
						ajax.call(this.action, xssfilter($(reviewListControlForm).serialize()), 'json', function(data){
							if(data.status == 'success') {
								var reviewList = data.data[0].reviewList;
								var html = _this.createList(reviewList);

								// pagination start
								var $target = $('.GPC0103 .review-list-footer');
								var pageInfo = data.data[0].pageInfo;
								// console.log(isExpander);
								if(isExpander) {
									$target.find('.pagination').hide();
									$('.GPC0103 .review-list-body').append(html);
									var pageVisible = pageInfo && pageInfo.view == "Y";
									if(pageVisible && pageInfo.page < pageInfo.pageCount) {
										$target.find('.expander button').get(0).value = pageInfo.page+1;
										$target.find('.expander').show();
									}else {
										$target.find('.expander').hide();
									}
								}else {
									$target.find('.expander').hide();
									$('.GPC0103 .review-list-body').html(html);

									// setting pagination
									if(pageInfo && pageInfo.view == "Y") {
										if($target.find('.pagination').get(0)){
											var pageMarkup = [];
											for (var pageIdx = pageInfo.loopStart; pageIdx <= pageInfo.loopEnd; pageIdx++) {
												var _pageItem = $(paginationTemplate).clone().html();
												_pageItem = $(_pageItem).get(0),
												_pageButton = _pageItem.querySelector('button');
												_pageButton.value = pageIdx;
												_pageButton.innerHTML = pageIdx;
												if(pageIdx.toString() == pageInfo.page) {
													_pageButton.setAttribute('class', 'active');
													// WA-GPC0030-06 : aria-current 추가
													_pageButton.setAttribute('aria-current', 'page');
												}
												if($target.find('.pagination').attr('data-aria-pattern')) {
													var _ariaText = $target.find('.pagination').attr('data-aria-pattern').replace(/\#/g, pageIdx);
													_pageButton.setAttribute('aria-label', _ariaText);
												}
												pageMarkup += _pageItem.outerHTML;
											}
											$target.find('.pagination ul').html(pageMarkup);

											$target.find('.pagination .prev').get(0).disabled = !pageInfo.leftPage;
											$target.find('.pagination .next').get(0).disabled = !pageInfo.rightPage;
											$target.find('.pagination .prev').get(0).value = pageInfo.page-1;
											$target.find('.pagination .next').get(0).value = pageInfo.page+1;
											$target.find('.pagination').show();
										}
									}else {
										$target.find('.pagination').hide();
									}

									if(flag != true) {
										$('html, body').animate({
											// 20200408 START 박지영 : 스크롤 위치 수정
											scrollTop: $('.GPC0103 .review-list-body').offset().top - parseInt($('.GPC0011').outerHeight())
											// 20200408 END
										});
									}
								}
								
								c0103.comment.init();
								c0103.cookie.getHelpfulReview(c0103.modelId);
								// pagination end

								// add event
								setTimeout(function() {
									$('.GPC0103 .review-list-body .contents-wrap').on({
										click: function(e){
											e.preventDefault();
											var del = e.delegateTarget;
											$(del).find('.contents').hide();
											$(del).find('.more-contents').show();
										}
									}, '.view-more');
									$('.GPC0103 .review-list-body .contents-wrap').on({
										click: function(e){
											e.preventDefault();
											var del = e.delegateTarget;
											$(del).find('.contents').show();
											$(del).find('.more-contents').hide();
										}
									}, '.hide-review');
								}, 500);

							}
							
						});
					}
				});
			},
			createList: function(reviewList){
				var html = [];
				for (var i = 0; i < reviewList.length; i++) {
					var msgMore = c0103.review.msgMore,
						msgLess = c0103.review.msgLess;
					var template = c0103.review.template.clone().html(),
							p = reviewList[i];
					if(p.reviewStatus == "A"){
						var ratesPercentage = (Number(p.rating) / 5 * 100) +"%";
						// 20200416 START 박지영 - br 대신 공백 처리
						/* LGEJP-161 : 20210111 add */
						p.review = p.review.replace(/\r\n|\n|\r/g, '<br>');
						/*// LGEJP-161 : 20210111 add */
						// 20200416 END
						template = template
							.replace(/\*reviewReId\*/g, p.reviewReId)
							.replace(/\*reviewId\*/g, p.reviewId)
							.replace(/\*rates\*/g, p.rating)
							.replace(/\*ratespercentage\*/g, ratesPercentage)
							.replace(/\*author\*/g, p.nickName)
							.replace(/\*time\*/g, p.creationDate)
							.replace(/\*title\*/g, p.title)
							.replace(/\*reviewText\*/g, p.review) /* LGEJP-161 : 20210111 add */
							.replace(/\*helpfulCount\*/g, p.helpful);
						
						// LGEGMC-495 start
						var $template = $(template);
						if( p.reviewUploadFlag == "Y"){
							var uploadTxt = $template.find(".comment-menu")[0].dataset;
							// LGEGMC-2398, LGEGMC-2494
							if( p.userType == "C" || p.originalLocaleCode == COUNTRY_CODE.toUpperCase()){
								if( uploadTxt.postMsgTypeC == "N" || uploadTxt.postMsgTypeC == "component-postUpoladComment-typeC"){
									$template = $(template.replace(/\*reviewUploadText\*/g, ""));
									$template.find('.post-where').remove();
								}else{
									$template = $(template.replace(/\*reviewUploadText\*/g, uploadTxt.postMsgTypeC));
								}
							} else {
								if( uploadTxt.postMsg == "N" || uploadTxt.postMsg == "component-postUpoladComment"){
									$template = $(template.replace(/\*reviewUploadText\*/g, ""));
									$template.find('.post-where').remove();
								}else{
									$template = $(template.replace(/\*reviewUploadText\*/g, uploadTxt.postMsg+"/"+p.originalLocaleCode));
								}
							}
							// LGEGMC-2398, LGEGMC-2494 End
						}else{
							$template = $(template.replace(/\*reviewUploadText\*/g, ""));
							$template.find('.post-where').remove();
						}
						// LGEGMC-495 end
						
						if(p.recommendFlag == "Y") {
							$template.find('.disrecommend').remove();
						}else if(p.recommendFlag == "N") {
							$template.find('.recommend').remove();
						}else {
							$template.find('.disrecommend').remove();
							$template.find('.recommend').remove();
						}

						if(Number(p.isModify) == 0) {
							$template.find('.review-control').remove();
						}

						// ie fix
						$template.find('.carmine-star').css({
							width: ratesPercentage
						});

						$template.find('.deleted-review').remove();
						$template.find('.submit-description').remove();

						var textLengthOverCut = function(txt, len, lastTxt) {
							if (len == "" || len == null) {len = 20;}
							if (lastTxt == "" || lastTxt == null) {lastTxt = "...";}
							if (txt.length > len) {
								txt = txt.substr(0, len) + lastTxt;
							}
							return txt;
						};

						// show/hide 
						var maxLen = 440;
						if($(window).width()<=1325) maxLen=300;
						if($(window).width()<768) maxLen=200;
						if(p.review.length > maxLen) {
							/* LGEJP-161 : 20210111 add */
							var tmp = '<div class="content">'+textLengthOverCut(p.review, maxLen)+' <a href="#" class="view-more">'+msgMore+'</a></div> <div class="contents more-contents">'+p.review+' <a href="#" class="hide-review">'+msgLess+'</a></div>';
							/*// LGEJP-161 : 20210111 add */
							$template.find('.contents-wrap').eq(0).empty().html(tmp);
						}

					}else { // removed review case
						var ratesPercentage = "0%";
						template = template.replace(/\*reviewReId\*/g, p.reviewReId)
											.replace(/\*reviewId\*/g, p.reviewId)
											.replace(/\*rates\*/g, 0)
											.replace(/\*ratespercentage\*/g, ratesPercentage);


						var $template = $(template);

						if(p.reviewStatus.toUpperCase() == "D") {
							// user delete case
							$template.find('.deleted-review.admin').remove();
						}else if(p.reviewStatus.toUpperCase() == "H") {
							// admin delete case
							$template.find('.deleted-review.user').remove();
						}

						$template.find('.subject').remove();
						$template.find('.contents-wrap').remove();
						$template.find('.comment-header').remove();
						$template.find('.rating-area .author').remove();
						$template.find('.rating-area .date').remove();
						// 20200413 START 박지영 - 삭제 된 컨텐츠의 경우, 추천 여부 표시가 데스크탑 버전에서만 제거 되던 버그 수정
						$template.find('.recommend').remove();
						$template.find('.disrecommend').remove();
						// 20200413 END
						$template.find('.review-control').remove();

						$template.find('.submit-description').remove();
					}
					if(p.commentList.length > 1) {
						$template.find('.review-control .edit').remove();
						var commentTemplate;
						var commentList = [];
						for (var j = 0; j < p.commentList.length; j++) {
							var cTemplate = c0103.comment.commentTemplate.clone().html(),
								curComment = p.commentList[j];
							curComment.comment = curComment.comment.replace(/\r\n|\n|\r/g, '<br>');
							if(j == 0) {
								cTemplate = cTemplate.replace(/\*commentReId\*/g, curComment.commentReId + curComment.reviewId)
											.replace(/\*commentId\*/g, curComment.commentId)
											.replace(/\*author\*/g, curComment.nickName)
											.replace(/\*time\*/g, curComment.creationDate)
											.replace(/\*commentText\*/g, curComment.comment)
											.replace(/\*commentTotalNumber\*/g, p.commentList.length-1);

								var $cTemplate = $(cTemplate);
								if(curComment.isModify == false) {
									$cTemplate.find('.comment-control').remove();
								}
								commentTemplate = $cTemplate.get(0).outerHTML;
							}else {
								var commentBox = c0103.comment.commentTemplate.clone().html();
								commentBox = $(commentBox).find('.comment-box').get(0).outerHTML;
								commentBox = commentBox.replace(/\*commentReId\*/g, curComment.commentReId + curComment.reviewId)
											.replace(/\*commentId\*/g, curComment.commentId)
											.replace(/\*author\*/g, curComment.nickName)
											.replace(/\*time\*/g, curComment.creationDate)
											.replace(/\*commentText\*/g, curComment.comment);
								var $commentBox = $(commentBox);
								if(curComment.isModify == false) {
									$commentBox.find('.comment-control').remove();
								}
								commentList += $commentBox.get(0).outerHTML;
							}
						}
						var $commentTemplate = $(commentTemplate);
						$commentTemplate.find('.more-comment').append(commentList);
						$commentTemplate.find(".submit-description").remove();
						$template.find('.comment-area').append($commentTemplate.get(0).outerHTML);
					}else if(p.commentList.length == 1) {
						$template.find('.review-control .edit').remove();
						var commentTemplate;
						var cTemplate = c0103.comment.commentTemplate.clone().html(),
							curComment = p.commentList[0];

						curComment.comment = curComment.comment.replace(/\r\n|\n|\r/g, '<br>');
						cTemplate = cTemplate.replace(/\*commentReId\*/g, curComment.commentReId + curComment.reviewId)
									.replace(/\*commentId\*/g, curComment.commentId)
									.replace(/\*author\*/g, curComment.nickName)
									.replace(/\*time\*/g, curComment.creationDate)
									.replace(/\*commentText\*/g, curComment.comment);
									
						var $cTemplate = $(cTemplate);
						if(curComment.isModify == false) {
							$cTemplate.find('.comment-control').remove();
						}
						commentTemplate = $cTemplate.get(0).outerHTML;

						var $commentTemplate = $(commentTemplate);
						$commentTemplate.find(".collapsed").removeClass("collapsed");
						$commentTemplate.find(".submit-description").remove();
						$template.find('.comment-area').append($commentTemplate.get(0).outerHTML);
					}

					// console.log($template.get(0).outerHTML);
					html += $template.get(0).outerHTML;
				}
				// $('.GPC0103 .review-list-body').html(html);
				return html;
			},
			addEvent:function(){
				// 20200608 START 박지영 - most-review-area 영역이 삭제 됨에 따라 관련 스크립트 삭제 
				/*
				$('.GPC0103 .most-review-area .see-more-reviews').on({
					click: function(e){
						e.preventDefault();
						var mostHelpful = e.currentTarget.getAttribute('data-value');
						reviewListControlForm.mostHelpful.value = mostHelpful;
						reviewListControlForm.page.value = 1;
						reviewListControlForm.sortBy.value = "";
						$(reviewListControlForm.sortBy).trigger('chosen:updated');
						$(reviewListControlForm).trigger('change');
					}
				});
				*/
				// 20200608 END
				$(reviewListControlForm.sortBy).on({
					change: function(e){
						reviewListControlForm.page.value = 1;
						reviewListControlForm.mostHelpful.value = '';
					}
				});
				$('.GPC0103').on({
					click: function(e){
						e.preventDefault();
						var page = e.currentTarget.value,
							targetForm = reviewListControlForm,
							_del = e.delegateTarget;

						targetForm.page.value = page;

						if($(e.currentTarget).closest('.expander')[0]) {
							$(_del).data('focus', true);
						}else {
							$(_del).data('focus', false);
							var pagePosition = "";
							if($(e.currentTarget).is(".prev")) {
								pagePosition = "L";
							}else if($(e.currentTarget).is(".next")){
								pagePosition = "R";
							}
							targetForm.pagePosition.value = pagePosition;
						}

						$(targetForm).trigger('change', [false]);
					}
				}, '.pagination button, .expander button');
			}
		},
		init: function(){
			this.modelId = writeReviewForm.modelId.value;
			//LGEITF-376 START
			var self = this;
			setTimeout(function() {
				self.checkMember();
			}, 200);
			//LGEITF-376 END
			this.review.init();
			this.comment.init();
			// 20200408 START 박지영 B type 추가
			this.type = ($('.GPC0103').data('type') === undefined) ? false : true;
			// 20200408 END
			// LGEPA-27
			if ($('.GPC0103').data('review-comfirm-selective-use-flag') === undefined) {
				this.reviewConfirmSelectiveUseFlag = 'N';
			} else {
				this.reviewConfirmSelectiveUseFlag = $('.GPC0103').data('review-comfirm-selective-use-flag');
			}
			// LGEPA-27 End
			if($('#reviewListControlForm').get(0)){
				this.list.init();
			}
			if($('#editReviewSignIn').get(0)){
				this.guestSignin();
			}
			this.addEvent();
			// 20200413 START 박지영 : 페이지 로딩시 로그인을 사용하지 않는 국가의 경우 Sign in as guest 팝업에서 signin-desc 영억 삭제 
			if(!c0103.loginURL) {
				$('#modal_signin_guest_edit .modal-body .signin-desc').remove();
				$('#modal_signin_guest_delete .modal-body .signin-desc').remove();
			}
			// 20200413 END
		},
		guestSignin: function(){
			var _this = this;
			// edit review ajax
			$(editReviewSignIn).on({
				submit: function(e){
					e.preventDefault();
					if($(this).checkValidation()) {
						ajax.call(this.action, xssfilter($(this).serialize()), 'json', function(data){
							if(data.status == "success") {
								$('#modal_signin_guest_edit').modal('hide');
								_this.review.pasteEditReview(editReviewSignIn.reviewId.value);
							} else {
								$(editReviewSignIn.password).closest('.field-block').addClass('error').find('.error-msg .ajax-msg')
								.text(data.errorMsg).show().siblings().hide();
							}
						});
					}
				}
			});
			// delete review ajax
			$(deleteReviewSignIn).on({
				submit: function(e){
					e.preventDefault();
					$('#modal_delete_confirm').modal('hide');
					if($(this).checkValidation()) {
						var url = this.action;
						if($(this).closest('#modal_signin_guest_delete').data('status') == 'comment') {
							url = this.getAttribute('data-comment-url');
						}
						ajax.call(url, xssfilter($(this).serialize()), 'json', function(data){
							if(data.status == "success" && data.data[0].deleteReview == "success") {
								// delete review / comment
								// 20200416 START 박지영 - 리로드 후 review 찾아가도록 수정
								location.replace(location.pathname+'?review=y')
								//location.reload();
								// 20200416 END
							} else {
								$(deleteReviewSignIn.password).closest('.field-block').addClass('error').find('.error-msg .ajax-msg')
								.text(data.errorMsg).show().siblings().hide();
							}
						});
					}
				}
			});
			$(deleteReviewSignIn).find('input').on({
				keydown: function(e){
					if(e.keyCode === 13) {
						e.preventDefault();
					}
				}
			});
			// 20200413 START 박지영 : delete review modal 의 sign-in 버튼을 클릭했을때 확인 팝업 띄우기 전에 validation 체크하도록 수정
			$(deleteReviewSignIn).closest('.modal-content').find('.modal-footer a.btn').removeAttr('data-toggle').on({
				click: function(e) {
					e.preventDefault();
					if($(deleteReviewSignIn).checkValidation()) {
						$('#modal_delete_confirm').modal('show');
					}
				}
			});
			// 20200413 END
		},
		checkPasswordPattern: function(val){
			var result = false;
			if (val.length > 7) {
				var n = /^.*(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).*$/;
				result = n.test(val);
			}
			return result;
		},
		checkMember:function(){
			var token = sessionStorage.getItem('ACCESS_TOKEN'); /* LGEITF-376 modify */
			// 20200416 START 박지영 - 리로드 후 review 찾아가도록 수정
			if(location.search.toUpperCase().indexOf('REVIEW=Y') > -1) {
				history.pushState(null, null, window.location.href.replace('?review=y', ''));
				setTimeout(function() {
					if($('.GPC0011').length>0) {
						$('.GPC0011 .tab-menu-belt .tab-menu a[href="#pdp_review"]').click();
					}
				}, 500);
			}
			// 20200416 END
			if(location.search.toUpperCase().indexOf('GUEST=Y') > -1) {
				$('#writeReviewButton').attr('href', "#");
				history.pushState(null, null, window.location.href.replace('?guest=Y', ''));
				setTimeout(function() {
					$('.GPC0009 .rating.inhouse-review a.write-a-review').trigger('click');
				}, 300);
			} else if(token) {
				// 20200413 START 박지영 : loginURL을 c0103.loginURL로 변경
				ajax.noCacheCall(c0103.loginURL, 'access_token='+token, 'json', function (data) {
				// 20200413 END
					if(data.loginCheck && data.loginCheck == true) {
						$('.GPC0103 .guest-area').remove();
						/* LGEIS-129 : 20200901 add */
						if(COUNTRY_CODE == 'it') $('.GPC0103 .agreement-area').remove();
						/* LGEIS-129 : 20200901 add */
						$('#writeReviewButton').attr('href', "#");
					}
				}, 'post');
			// 20200408 START 박지영 - 로그인기능을 사용하지 않는 국가
			// 20200413 START 박지영 : loginURL을 c0103.loginURL로 변경
			} else if(!c0103.loginURL) {
			// 20200413 END
				// login 을 사용하지 않는 국가
				$('#writeReviewButton').attr('href', "#");
			// 20200408 END
			}
		},
		addEvent: function(){
			$('.GPC0103 .contents-wrap').on({
				click: function(e){
					e.preventDefault();
					var del = e.delegateTarget;
					$(del).find('.contents').hide();
					$(del).find('.more-contents').show();
				}
			}, '.view-more');
			$('.GPC0103 .contents-wrap').on({
				click: function(e){
					e.preventDefault();
					var del = e.delegateTarget;
					$(del).find('.contents').show();
					$(del).find('.more-contents').hide();
				}
			}, '.hide-review');
			$('.GPC0103 .modal').on({
				'hidden.bs.modal': function(e){
					$(e.currentTarget).find('.field-block').removeClass('error');
					// $(e.currentTarget).find('form').each(function(){
					// 	this.reset();
					// });
				}
			});
		}
	}
	c0103.init();
	//PJTGADL-2
	$('body').on('click', '.GPC0103 #writeReviewButton', function () {
		var modelYear = nvl($('.js-compare').attr('data-model-year'), '');
		var eventName = '';
		var price = '';
		price = $('.js-compare').attr('data-price');
		if($('.js-compare').attr('data-price') == '.' || $('.js-compare').attr('data-price') == '.00' || $('.js-compare').attr('data-price') == '0.0' || $('.js-compare').attr('data-price') == '0'){
			price = "";
		} 
		var msrp = $('.js-compare').attr('data-msrp');
		if($('.js-compare').attr('data-msrp') == '.' || $('.js-compare').attr('data-msrp') == '.00' || $('.js-compare').attr('data-msrp') == '0.0' || $('.js-compare').attr('data-msrp') == '0'){
			msrp = "";
		} 
			dataLayer.push({
				'event'			: 'move_to_write_review_click',
				'superCategory'	: $('.js-compare').attr('data-super-category-name'),
				'category'		: $('.js-compare').attr('data-category-name'),
				'subcategory'	: $('.js-compare').attr('data-sub-category-name'),
				'modelYear'		: modelYear,
				'modelName'		: $('.js-compare').attr('data-model-name'),
				'modelCode'		: $('.js-compare').attr('data-model-id'),
				'salesModelCode': $('.js-compare').attr('data-model-salesmodelcode'),
				'sku'			: $('.js-compare').attr('data-sku'),
				'suffix'        : $('.js-compare').attr('data-model-suffixcode'),
				'bu'            : $('.js-compare').attr('data-bu'),
				'price'         : price,
				'currencyCode'  : $('.currency-code').val(),
				'dimension185'  : $('.navigation').attr('data-obs-group'),
				'metric4'       : msrp
			});
		console.log('move_to_write_review_click');
		});
		
	
	/*
	if(window.location.search.indexOf('guest=Y') >=0) {
		history.pushState(null, null, window.location.href.replace('?guest=Y', ''));
		setTimeout(function() {
			$('.GPC0009 .rating.inhouse-review a.write-a-review').trigger('click');
		}, 300);
	}
	*/
});